var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
    i,
    q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;
  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};
var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
    i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }
  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};
function initLivePersonMessagesStatusManager() {
  var _a;
  var _this = this;
  // Client: We only keep tracking client specific message status
  var statusMapByMsgId = new Map(); // { [msgId]: [message status] }
  var sequenceIdMap = new Map(); // { [sequenceId]: [msgId] }
  // Agent: all messages from the LP service that don't have a status yet
  var pendingAgentSequenceIds = []; // all messages sequence id that don't have a status(ACCEPT, READ)
  // Pending message status Queue
  var pendingMessageStatusQueue = (_a = {
    messageStatusPending: false,
    messages: [],
    enqueue: function (message) {
      this.messages.push(message);
    }
  }, _a[Symbol.asyncIterator] = function () {
    return __asyncGenerator(this, arguments, function _a() {
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!this.messages.length) return [3 /*break*/, 3];
            return [4 /*yield*/, __await(this.messages.shift())];
          case 1:
            return [4 /*yield*/, _b.sent()];
          case 2:
            _b.sent();
            return [3 /*break*/, 0];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }, _a);
  return {
    updateMessageStatusByMsgId: function (msgId, status) {
      statusMapByMsgId.set(msgId, status);
    },
    linkSequenceIdWithMsgId: function (msgId, sequenceId) {
      sequenceIdMap.set(sequenceId, msgId);
    },
    getMsgIdBySequenceId: function (sequenceId) {
      if (sequenceIdMap.has(sequenceId)) {
        return sequenceIdMap.get(sequenceId);
      }
      return '';
    },
    getStatusByMsgId: function (msgId) {
      if (statusMapByMsgId.has(msgId)) {
        return statusMapByMsgId.get(msgId);
      }
      return '';
    },
    getPendingAgentSequenceIds: function () {
      return pendingAgentSequenceIds;
    },
    clearPendingAgentSequenceIds: function () {
      pendingAgentSequenceIds = [];
    },
    addPendingAgentSequenceIds: function (id) {
      pendingAgentSequenceIds.push(id);
    },
    updatePendingMessageStatus: function (cb) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, pendingMessageStatusQueue_1, pendingMessageStatusQueue_1_1, cb_1, e_1_1;
        var _b, e_1, _c, _d;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (cb) {
                pendingMessageStatusQueue.enqueue(cb);
              }
              if (!!pendingMessageStatusQueue.messageStatusPending) return [3 /*break*/, 16];
              pendingMessageStatusQueue.messageStatusPending = true;
              _e.label = 1;
            case 1:
              _e.trys.push([1, 9, 10, 15]);
              _a = true, pendingMessageStatusQueue_1 = __asyncValues(pendingMessageStatusQueue);
              _e.label = 2;
            case 2:
              return [4 /*yield*/, pendingMessageStatusQueue_1.next()];
            case 3:
              if (!(pendingMessageStatusQueue_1_1 = _e.sent(), _b = pendingMessageStatusQueue_1_1.done, !_b)) return [3 /*break*/, 8];
              _d = pendingMessageStatusQueue_1_1.value;
              _a = false;
              _e.label = 4;
            case 4:
              _e.trys.push([4,, 6, 7]);
              cb_1 = _d;
              return [4 /*yield*/, cb_1()];
            case 5:
              _e.sent();
              return [3 /*break*/, 7];
            case 6:
              _a = true;
              return [7 /*endfinally*/];
            case 7:
              return [3 /*break*/, 2];
            case 8:
              return [3 /*break*/, 15];
            case 9:
              e_1_1 = _e.sent();
              e_1 = {
                error: e_1_1
              };
              return [3 /*break*/, 15];
            case 10:
              _e.trys.push([10,, 13, 14]);
              if (!(!_a && !_b && (_c = pendingMessageStatusQueue_1.return))) return [3 /*break*/, 12];
              return [4 /*yield*/, _c.call(pendingMessageStatusQueue_1)];
            case 11:
              _e.sent();
              _e.label = 12;
            case 12:
              return [3 /*break*/, 14];
            case 13:
              if (e_1) throw e_1.error;
              return [7 /*endfinally*/];
            case 14:
              return [7 /*endfinally*/];
            case 15:
              pendingMessageStatusQueue.messageStatusPending = false;
              _e.label = 16;
            case 16:
              return [2 /*return*/];
          }
        });
      });
    }
  };
}
export var livePersonMessagesStatusManager = initLivePersonMessagesStatusManager();